import React from 'react';
import Navbar from '../../components/Navbar2';
import Contact from '../../components/Contact';
import './index.css';

const OdeToTheArtsPage = () => {
  return (
    <div className="collection-page">
      <Navbar />

      {/* Hero Section */}
      <div
        className="collection-hero"
        style={{
          backgroundImage: "url('https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxe%2Fgetty-images-wnA23EFrwNw-unsplash.jpg?alt=media&token=ffc4bb27-c4bb-4fdb-b20a-47f81ac5874f')",
        }}
      >
        <div className="collection-hero-overlay" />
        <div className="collection-hero-content">
          <p className="collection-hero-label">Collections</p>
          <h1 className="collection-hero-title">Ode to the Arts</h1>
          <p className="collection-hero-sub">
            Where culture, creativity, and luxury converge in perfect harmony.
          </p>
        </div>
      </div>

      {/* Coming Soon Section */}
      <div className="collection-coming-soon">
        <p className="collection-cs-label">Coming Soon</p>
        <h2 className="collection-cs-title">Launching After Asia Wonderlust</h2>
        <p className="collection-cs-text">
          Our Ode to the Arts collection celebrates the world's most culturally rich destinations — properties nestled in cities of art, music, and architecture. A collection for those who seek beauty in every form.
        </p>
        <div className="collection-cs-divider" />
        <p className="collection-cs-notify">
          Register your interest to be notified when this collection launches.
        </p>
      </div>

      <Contact />
    </div>
  );
};

export default OdeToTheArtsPage;
